import { render, staticRenderFns } from "./CreateLeadFormStep1.vue?vue&type=template&id=264a1047&"
import script from "./CreateLeadFormStep1.vue?vue&type=script&lang=ts&"
export * from "./CreateLeadFormStep1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports